// Copy a plain-old-data JSON type
function copy(value) {
  if (!value) {
    return value;
  } else if (value instanceof Map) {
    return new Map(value);
  } else if (value instanceof Set) {
    return new Set(value);
  } else if (Array.isArray(value)) {
    return value.slice();
  } else if (typeof value === 'object') {
    return Object.assign({}, value);
  } else {
    return value;
  }
}

// Update a single property in a deep object tree
// while doing the minimum of shallow copying to maintain immutability.
// object: The object to return an updated shallow copy of.
// path:   Array of property names indicating where in the object tree to update.
//         Each path value can be:
//          - a string to access the property by that name
//          - an integer to access that index in an array
//          - a function that takes the current node as an argument and returns
//            the property to access
// update: The value to place at the property indicated by path. If it is a
//         a function, it will be called with the current value and should return
//         the new value. Do not mutate the current value. If you want to set
//         the value to a function itself, you must wrap it in a function.
export default function shallowCloneUpdateIn(object, path, update) {
  if (!path || !path.length) {
    throw new Error('Invalid path array');
  }
  const result = copy(object);
  let node = result;
  for (let i = 0; i < path.length; i++) {
    let property = path[i];
    if (typeof property === 'function') {
      property = property(node);
    }
    if (property === -1 || (!property && property !== 0)) {
      throw new Error(
        `Property name '${property}' at path index ${i} is invalid`
      );
    }
    if (i === path.length - 1) {
      if (typeof update === 'function') {
        node[property] = update(node[property]);
      } else {
        node[property] = update;
      }
    } else {
      if (!node.hasOwnProperty(property)) {
        throw new Error(
          `Property '${property}' at path index ${i} is undefined`
        );
      }
      node[property] = copy(node[property]);
      node = node[property];
    }
  }

  return result;
}
